import { InjectionToken } from '@angular/core'
import {
  TotpMultiFactorGenerator,
  applyActionCode,
  sendEmailVerification,
  getIdTokenResult,
  multiFactor,
  signOut,
  onAuthStateChanged,
  onIdTokenChanged,
  signInWithEmailAndPassword,
  signInWithPopup,
  signInWithCustomToken,
  getMultiFactorResolver,
  sendPasswordResetEmail,
  verifyPasswordResetCode,
  confirmPasswordReset,
} from '@angular/fire/auth'

export interface FirebaseAuthSdk {
  totpMultiFactorGenerator: Pick<
    typeof TotpMultiFactorGenerator,
    'generateSecret' | 'assertionForEnrollment' | 'assertionForSignIn'
  >
  applyActionCode: typeof applyActionCode
  sendEmailVerification: typeof sendEmailVerification
  getIdTokenResult: typeof getIdTokenResult
  multiFactor: typeof multiFactor
  signOut: typeof signOut
  onIdTokenChanged: typeof onIdTokenChanged
  onAuthStateChanged: typeof onAuthStateChanged
  signInWithEmailAndPassword: typeof signInWithEmailAndPassword
  signInWithCustomToken: typeof signInWithCustomToken
  signInWithPopup: typeof signInWithPopup
  getMultiFactorResolver: typeof getMultiFactorResolver
  sendPasswordResetEmail: typeof sendPasswordResetEmail
  verifyPasswordResetCode: typeof verifyPasswordResetCode
  confirmPasswordReset: typeof confirmPasswordReset
}

export const FIREBASE_AUTH_SDK = new InjectionToken<FirebaseAuthSdk>(
  'FirebaseAuthSdk',
  {
    providedIn: 'root',
    factory: () => ({
      totpMultiFactorGenerator: TotpMultiFactorGenerator,
      applyActionCode,
      sendEmailVerification,
      getIdTokenResult,
      multiFactor,
      signOut,
      onAuthStateChanged,
      onIdTokenChanged,
      signInWithEmailAndPassword,
      signInWithPopup,
      signInWithCustomToken,
      getMultiFactorResolver,
      sendPasswordResetEmail,
      verifyPasswordResetCode,
      confirmPasswordReset,
    }),
  },
)
